import { store } from "../store/store";
import axios from "axios";
import { setMyPatients } from "../actions/doctor";
import { login, setPermissions } from "../actions/auth";
import { setUsers } from "../actions/admin";

export const loadProfile = async (uid, dispatch, finished) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;
  const data = await db.collection("users").doc(`${uid}`).get();

  let dataUser;
  if (data.data() === undefined) {
    return { typeUser: "patient" };
  } else {
    dataUser = data.data();

    if (
      dataUser.typeUser === "doctor" ||
      dataUser.typeUser === "doctor-perito"
    ) {
      db.collection("professional")
        .where("dni", "==", dataUser.dni)
        .get()
        .then((queryDoctor) => {
          queryDoctor.forEach((docProf) => {
            dataUser.countries = docProf.data().countries_attention[0];
            dataUser.patients = docProf.data().patient;

            dataUser = { ...dataUser, dataProf: {} };
            dataUser.dataProf.countrySchedule = dataUser.countries.label;
            dataUser.dataProf.medicalId = dataUser.medicalId ?? "";
          });

          dispatch(login(uid, dataUser));
          dispatch(setPermissions(dataUser.permissions));
          dispatch(setMyPatients(dataUser.patients));

          if (finished) {
            setTimeout(() => {
              finished(true);
            }, 1500);
          }
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });

  /*     db.collection("professional")
        .where("dni", "==", dataUser.dni)
        .onSnapshot((queryDoctor) => {
          queryDoctor.forEach((docProf) => {
            dataUser.countries = docProf.data().countries_attention[0];
            dataUser.patients = docProf.data().patient;

            dataUser = { ...dataUser, dataProf: {} };
            dataUser.dataProf.countrySchedule = dataUser.countries.label;
            dataUser.dataProf.medicalId = dataUser.medicalId ?? "";
          });

          dispatch(login(uid, dataUser));
          dispatch(setPermissions(dataUser.permissions));
          dispatch(setMyPatients(dataUser.patients));

          if (finished) {
            setTimeout(() => {
              finished(true);
            }, 1500);
          }
        }); */
    } else {
      dispatch(login(uid, dataUser));
      dispatch(setPermissions(dataUser.permissions));

      if (finished) {
        setTimeout(() => {
          finished(true);
        }, 1500);
      }
    }
  }
  return dataUser;
};

export const loadSearch = async (search, uid) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  const respuesta = await db
    .collection(`${uid}/jurnal/notes`)
    .where("title", "==", search)
    .get();
  const tasks = [];

  respuesta.forEach((task) => {
    tasks.push({
      id: task.id,
      ...task.data(),
    });
  });
  return tasks;
};

export const loadUsers = async (dispatch) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState.companyInstance.urlServer;

  const users = [];

  axios.get(`${urlServer}/getUsersCompany`).then((usersResponse) => {
    const { data } = usersResponse;
    data.forEach((usr) => {
      if (usr.dni) {
        const nameComplete = `${
          (usr.nameFirst.trim() !== ""
            ? usr.nameFirst.trim().toUpperCase()
            : "") +
          (usr.nameSecond.trim() !== ""
            ? " " + usr.nameSecond.trim().toUpperCase()
            : "") +
          (usr.lastnameFirst.trim() !== ""
            ? " " + usr.lastnameFirst.trim().toUpperCase()
            : "") +
          (usr.lastnameSecond.trim() !== ""
            ? " " + usr.lastnameSecond.trim().toUpperCase()
            : "")
        }`;
        users.push({
          ...usr,
          dni: usr.dni ?? "",
          nameComplete,
          nameFirst: usr.nameFirst ?? "",
          nameSecond: usr.nameSecond ?? "",
          lastnameFirst: usr.lastnameFirst ?? "",
          lastnameSecond: usr.lastnameSecond ?? "",
        });
      }
    });

    users.sort((a, b) => a.nameFirst.localeCompare(b.nameFirst));
    dispatch(setUsers(users));
  });
};

export const searchUserByRut = async (dniUser) => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  let user = [];

  await db
    .collection("users")
    .where("dni", "==", dniUser)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        user.push({
          ...doc.data(),
        });
      });
    })
    .catch((error) => {
      console.log("Error getting documents: ", error);
    });

  return user;
};

export const loadTypeConsultation = async () => {
  const reduxState = store.getState().company;
  const db = reduxState.companyInstance.db;

  await db.collection("typeconsultation").onSnapshot(
    (snapshot) => {
      const typesconsultation = [];
      snapshot.forEach((doc) => {
        typesconsultation.push({
          ...doc.data(),
        });
      });
      return typesconsultation;
    },
    (error) => {
      console.log("Error getting documents: ", error);
    }
  );
};